let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bI6N0")).then(() => parcelRequire('evqpq'));